/**
 * Accent: Andean terracotta — adobe walls, colonial Cusco, desert clay at dusk.
 * Distinct from the site default amber; reads clearly on white.
 */
export const machuTheme = {
  accentText: 'text-[#b94d3c]',
  accentBg: 'bg-[#b94d3c]',
} as const
